export default __webpack_public_path__ + "static/media/exclude-active.b538e36d.svg";